document.querySelectorAll('.card__colors').forEach(container => {
  const swatches = container.querySelectorAll('color-swatch');
  if (!swatches.length) return;

  // Highlight first by default
  swatches[0].classList.add('is-active');

  swatches.forEach(swatch => {
    swatch.addEventListener('click', () => {
      swatches.forEach(s => s.classList.remove('is-active'));
      swatch.classList.add('is-active');
    });
  });
});